import React, { useEffect, useRef } from 'react';
import './Toast.css';

const Toast = ({
  id,
  type = 'success',
  message,
  duration = 4000,
  onClose
}) => {
  const toastRef = useRef(null);
  const timeoutRef = useRef(null);
  const progressRef = useRef(null);

  const icons = {
    success: '✓',
    error: '!',
    warning: '⚠',
    info: 'ℹ',
  };

  useEffect(() => {
    if (progressRef.current) {
      progressRef.current.style.animationDuration = `${duration}ms`;
    }

    timeoutRef.current = setTimeout(() => {
      handleClose();
    }, duration);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [duration]);

  const handleClose = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (toastRef.current) {
      toastRef.current.classList.add('closing');

      setTimeout(() => {
        onClose(id);
      }, 400);
    } else {
      onClose(id);
    }
  };

  return (
    <div
      ref={toastRef}
      className={`toast ${type}`}
      onMouseEnter={() => {
        if (progressRef.current) {
          progressRef.current.style.animationPlayState = 'paused';
        }

        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      }}
      onMouseLeave={() => {
        if (progressRef.current) {
          progressRef.current.style.animationPlayState = 'running';
        }

        timeoutRef.current = setTimeout(() => {
          handleClose();
        }, duration);
      }}
    >
      <div className="toast-content">

        <div className={`toast-icon ${type}`}>
          {icons[type] || '✓'}
        </div>

        <div className="toast-message">
          {message}
        </div>

        <button
          className="toast-close"
          onClick={handleClose}
          type="button"
        >
          ×
        </button>

      </div>

      <div className="toast-progress-bg">
        <div
          ref={progressRef}
          className="toast-progress"
        />
      </div>
    </div>
  );
};

export default Toast;